// extracted by mini-css-extract-plugin
export default {"userSelectButton":"select-employee_userSelectButton__wDyli"};